module.exports = __webpack_public_path__ + "img/promotores.ce1c76ad.svg";